import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';

export class FiltroCoDocumentoCobrar {

    estado: string;
    cliente: number;
    desde: Date;
    hasta: Date;
    numero: string;
    conVencidos: any;
    nombreCliente: string;
    conAceptada: any;
    estadoletra: string;
    idVendedor: any;
    letraNumeroUnico: string;
    usuarioActualCompania: string;
  
    constructor() {
        this.paginacion = new ParametroPaginacionGenerico();
        this.paginacion.atributoOrdenar = 'fechaaprobacion';
    }
    paginacion: ParametroPaginacionGenerico;

}

